import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { useRef } from "react";

import { ShowcaseImageCardsBlock as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import styles from "./ShowcaseImageCards.module.scss";

gsap.registerPlugin(ScrollTrigger);

export const ShowcaseImageCards = ({ value }: { value: Value }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useGSAP(
        () => {
            const mm = gsap.matchMedia();

            mm.add(`(prefers-reduced-motion: no-preference)`, () => {
                gsap.fromTo(
                    containerRef.current,
                    { "--progress": 0 },
                    {
                        "--progress": 1,
                        "scrollTrigger": {
                            trigger: containerRef.current,
                            start: "top 70%",
                            end: "top 0%",
                            scrub: 0.1,
                        },
                    },
                );
            });

            return () => {
                mm.revert();
            };
        },
        { scope: containerRef },
    );

    return (
        <section className={styles.root}>
            <div className={styles.container} ref={containerRef}>
                <div className={styles.cardLeft}>
                    {value.left_image && (
                        <ImageChooserBlock
                            value={value.left_image}
                            attrs={{}}
                        />
                    )}
                </div>
                <div className={styles.cardCenter}>
                    {value.center_image && (
                        <ImageChooserBlock
                            value={value.center_image}
                            attrs={{}}
                        />
                    )}
                </div>
                <div className={styles.cardRight}>
                    {value.right_image && (
                        <ImageChooserBlock
                            value={value.right_image}
                            attrs={{}}
                        />
                    )}
                </div>
            </div>
        </section>
    );
};
